module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_location@3x-53154e6383565a6bcf81f7a6ee8d6a03.webp";